import { render, staticRenderFns } from "./PartnershipForecast.vue?vue&type=template&id=a85fa162&"
import script from "./PartnershipForecast.vue?vue&type=script&lang=js&"
export * from "./PartnershipForecast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports